import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import Button from './Button';
import * as CatizColors from './Colors';
import TextInput from './TextInput';
import WindowHeader from './WindowHeader';

const Container = styled.div`
  ${CatizColors.grayBorder}
`;
const Header = styled.div`
  display: grid;
  grid-template-columns: 85% 15%;
`;

const AlertTable = styled.div`
  display: grid;
  grid-template-columns: 70% 15% 15%;
`;
const HeaderCell = styled.div`
  background: ${CatizColors.lightBlue};
  text-align: center;
  ${CatizColors.grayBorder}
`;
const TableCell = styled.div<any>`
  color: ${CatizColors.whiteFont};
  ${CatizColors.grayBorder};
  padding-left: 5px;
  ${({ isEven }) => {
    if (!isEven) {
      return `background:${CatizColors.blue}`;
    }
    return `background:${CatizColors.deepBlue}`;
  }}
`;

const items = [
  { message: 'Unale to evaluate mode 4/5 response', pri: 80006, sec: '' },
  { message: 'CMS Communication with eoss on', pri: 80007, sec: '' },
  { message: 'Drop track', pri: 80004, sec: '' },
  { message: 'Drop track', pri: 80017, sec: '' },
  { message: 'Drop track', pri: 80021, sec: '' },
];

export default function AlertPanel() {
  const executor = useSelector((state: any) => state.executor);
  const { alerts, reviewAlert } = executor;
  return (
    <Container>
      <WindowHeader name={'Alerts Manager'} />
      <Header>
        <TextInput value={reviewAlert.title ?? ''} />
        <Button>Review</Button>
      </Header>
      <AlertTable>
        <HeaderCell>Alerts ({alerts.length})</HeaderCell>
        <HeaderCell> PRI</HeaderCell>
        <HeaderCell>SEC</HeaderCell>
        {alerts.map((item, index) => {
          return (
            <React.Fragment>
              <TableCell
                isEven={index % 2 === 0}
                style={{
                  textTransform: 'uppercase',
                }}
              >
                {item.title}
              </TableCell>
              <TableCell
                isEven={index % 2 === 0}
                style={{
                  textAlign: 'center',
                }}
              >
                {item.pri}
              </TableCell>
              <TableCell isEven={index % 2 === 0}>{item.sec}</TableCell>
            </React.Fragment>
          );
        })}
      </AlertTable>
    </Container>
  );
}
